// Central site configuration.
// SITE_URL is the canonical production domain used in:
//   - <link rel="canonical">
//   - og:url meta tag
//   - JSON-LD schema URLs (Article, Organization, Breadcrumb, ItemList)
//
// When deploying to a different domain, change this single constant.
// We intentionally hardcode the production domain (instead of using
// window.location.origin) so that canonical URLs always point to the
// real production site, preventing duplicate-content indexing from
// preview/staging environments.
// Central site configuration.
// SITE_URL is the canonical production domain used in:
//   - <link rel="canonical">
//   - og:url meta tag
//   - JSON-LD schema URLs (Article, Organization, Breadcrumb, ItemList)
//
// Reads from REACT_APP_SITE_URL env var (set in frontend/.env), falling back
// to the production domain. We intentionally do NOT use window.location.origin
// because canonical URLs and JSON-LD schema MUST always point to the real
// production domain regardless of preview/staging environment — this is correct
// SEO best practice (prevents duplicate-content indexing of preview URLs by Google).
export const SITE_URL = process.env.REACT_APP_SITE_URL || 'https://mygoguard.com';

// Logo paths (use directly in <picture> with WebP source + PNG fallback).
// See Navbar.js / Footer.js for canonical usage pattern.
//   - /goguard-logo.webp     (2.3 KB, 160×160)
//   - /goguard-logo@2x.webp  (5.2 KB, 320×320 retina)
//   - /goguard-logo.png      (70 KB, 320×320 fallback for older browsers)
